import styled from "styled-components";
import React from "react";

export const SubTopBar = styled.div`
  position: fixed;
  top: 60px;
  left: 0;
  right: 0;
  height: 60px;
  border-bottom: 1px solid #f0f0f0;
  background: white;
  z-index: 2;
`;
export const TopBarContent = styled.div`
  max-width: 1000px;
  margin: auto;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const TitleInput = styled.input`
  appearance: none;
  border: none;
  font-size: 2rem;
  font-weight: bold;
  color: black;
  &::placeholder {
    color: rgb(200,200,200);
  }
  &:focus {
    outline: none;
  }
`;

export const ToggleCircle = styled.div`
  position: absolute;
  top: 2px;
  height: 35px;
  width: 35px;
  border-radius: 18px;
  background: white;
  transition: .25s;
`;

export const ToggleWrapper = styled.div`
  margin-left: 1rem;
  position: relative;
  height: 39px;
  width: 70px;
  border-radius: 20px;
  cursor: pointer;
  background-color: ${(props: { value: boolean }) => props.value ? "#95ffd1" : "#EEEEEE"};
  transition: .25s;
  ${ToggleCircle} {
    left: ${props => props.value ? "33" : "2"}px;
  }
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  font-size: 1.2rem;
  font-weight: 600;
`;

export function Toggle(props: { value: boolean, onClick: () => void, label: string }) {

    return <Container>
        {props.label}
        <ToggleWrapper {...props}>
            <ToggleCircle />
        </ToggleWrapper>
    </Container>
}

export const AddContentButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  border-radius: 12px;
  border: 1px solid #EEEEEE;
  font-weight: bold;
  font-size: 18px;
  color: #949494;
  cursor: pointer;
  transition: .1s;
  margin-top: 1rem;
  &:hover {
    border-color: #c8c8c8;
  }
`;

export const Wrapper = styled.div`
  padding: .75rem;
  border: 1px solid #EEEEEE;
  border-radius: 12px;
`;

export const TitleImage = styled.div`
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  width: 100%;
  border: 1px solid #EEEEEE;
  padding-bottom: 33%;
  img {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
`;

export const Placeholder = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 4rem;
  background: #eeeeee;
  cursor: pointer;
  color: #CCCCCC;
  &:hover {
    color: #BBBBBB;
  }
`;

export const Input = styled.input`
  display: none;
`;
export const Label = styled.label`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  border-radius: 12px;
  cursor: pointer;
`;

export const Div = styled.div`
  position: relative;
  display: grid;
  gap: 1rem;
`;